<div>
  @if (label()) {
    <label class="dropdown-label" [for]="id()">{{ label() }}</label>
  }
  <p-select
    [options]="options"
    [formControl]="control"
    [placeholder]="placeholder()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [loading]="loading()"
    [scrollHeight]="scrollHeight()"
    [panelStyleClass]="panelStyleClass()"
    [overlayOptions]="overlayOptions()"
    [ngClass]="{
      'custom-invalid-class': control.invalid && (control.dirty || control.touched)
    }"
    styleClass="w-full"
  ></p-select>
  <app-error-message [errorMessage]="errorMessage()" [name]="name()" [control]="control" />
</div>
